<template>
    <PatientPreadmissionNotes
        v-if="referral"
        :application="application"
        :referral-id="referralId"
        :is-referral="true"
        :referral="referral"
        :closePreadmissionDialog="closePreadmissionDialog"
        :isPreadmissionDialog="true"
    />
</template>
<script lang="ts" src="./HosPalPreadmissionNotes.ts" />
